module.exports = __webpack_public_path__ + "img/chess-piece.0e17a0c3.svg";